const getOverriddenItems = (state: AnyFixMe) => state.rightClickMenu.overridden;

export { getOverriddenItems };
